import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

// redux
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../../store/actions";

const Logout = (props) => {
  const dispatch = useDispatch();

  const { isUserLogout } = useSelector((state) => ({
    isUserLogout: state.Login.isUserLogout,
  }));

  useEffect(() => {
    const handleLogout = async () => {
      try {
        // Retrieve access token from localStorage
        const accessToken = localStorage.getItem("accessToken");

        if (!accessToken) {
          toast.error("No access token found. Please log in again.", {
            position: "top-right",
            autoClose: 3000,
          });
          // Proceed with client-side logout
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          dispatch(logoutUser());
          return;
        }

        // Make the logout API call
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/auth/logout`,
          {},
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        // Show success toast with API message
        toast.success(
          response.responseMessage.data?.[0] || "Logged out successfully!",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );

        // Clear tokens from localStorage
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");

        // Dispatch logout action
        dispatch(logoutUser());
      } catch (error) {
        // Log error for debugging
        console.error("Logout error:", error.response || error.message);

        // Show error toast
        toast.error(
          error.response?.responseMessage?.data?.[0] || "Logout failed. Please try again.",
          {
            position: "top-right",
            autoClose: 3000,
          }
        );

        // Clear tokens and proceed with client-side logout
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        dispatch(logoutUser());
      }
    };

    handleLogout();
  }, [dispatch]);

  if (isUserLogout) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);